import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import HLifeLogo from "../../assets/images/AD/10/21/26075_14.svg";
import HDFCLOGO from "../../assets/images/AD/10/21/PASA.png"
import InstainsureLogo from "../../assets/images/AD/10/21/26075_21.svg";
import BelairLogo from "../../assets/images/AD/10/21/26075_37.svg";
import IDFCLogo from "../../assets/images/AD/10/21/idfc_first_logo.webp";
import { BELAIR_PARTNER } from "../../configs/partner";
export default function AppHeader({ ...props }) {
  const history = useHistory();
  const { pasaStore } = useSelector((state) => state);
  const { source, openMarket } = pasaStore;
  const isLeadCapture = openMarket?.source?.toUpperCase() === 'LEAD_CAPTURE'
  const rtlHbank = openMarket?.source?.toUpperCase() === 'RTL_HBANK'
  const isCrossSell = openMarket?.source?.toUpperCase() === "CROSS_SELL"
  const isNonHbank = openMarket?.source?.toUpperCase() === 'SELFSOURCE'
  // discarded temporarily for SEO purpose
  // useEffect(() => {
  //   if (
  //     pasaStore.source !== undefined &&
  //     pasaStore.source !== null &&
  //     pasaStore.source !== '' &&
  //     props.route !== 'welcome'
  //   ) {
  //     document.title = `InstaInsure | ${
  //       partnerNameMap[pasaStore.source] || 'HDFC Life'
  //     }`;
  //   } else {
  //     document.title = `InstaInsure`;
  //   }
  // }, []);
  const _stepper = () => {
    if (
      props.route === "declarations" ||
      props.route === "paymentFailure" ||
      props.route === "error" ||
      props.route === "drop" ||
      props.route === "openMarketForm" ||
      props.route === "offers" ||
      window.isMobileDevice
    ) {
      return <div></div>;
    }
    return (
      <div className="stepper-row">
        {openMarket?.journeytype === 'payout' && <>
          <div
          onClick={() => _handleNavClick("quote")}
          className={`step ${props.route === "planDetails" ? "active" : ""} ${[
            "basicDetails",
            "declarations",
            "nomineeDetails",
            "payment",
            "paymentSuccess",
            "summary"
          ].includes(props.route)
            ? "completed"
            : ""
            }`}
        >
          <span className="step-index">
            {[
              "basicDetails",
              "declarations",
              "nomineeDetails",
              "payment",
              "paymentSuccess",
              "summary"
            ].includes(props.route) ? (
              <i className="fas fa-check-square" />
            ) : (
              1
            )}
          </span>
          <span className="step-name">Plan Details</span>
        </div>
          <div
          onClick={() => _handleNavClick("basic-details")}
          className={`step ${props.route === "basicDetails" ? "active" : ""} ${[
            // "planDetails",
            "declarations",
            "nomineeDetails",
            "payment",
            "paymentSuccess",
            "summary"
          ].includes(props.route)
            ? "completed"
            : ""
            }`}
        >
          <span className="step-index">
            {[
              // "planDetails",
              "declarations",
              "nomineeDetails",
              "payment",
              "paymentSuccess",
              "summary"
            ].includes(props.route) ? (
              <i className="fas fa-check-square" />
            ) : (
              2
            )}
          </span>
          <span className="step-name">Basic Details</span>
        </div>
        
        </>}
        {openMarket?.journeytype !== 'payout' && <>
       <div
          onClick={() => _handleNavClick("basic-details")}
          className={`step ${props.route === "basicDetails" ? "active" : ""} ${[
            "planDetails",
            "declarations",
            "nomineeDetails",
            "payment",
            "paymentSuccess",
            "summary"
          ].includes(props.route)
            ? "completed"
            : ""
            }`}
        >
          <span className="step-index">
            {[
              "planDetails",
              "declarations",
              "nomineeDetails",
              "payment",
              "paymentSuccess",
              "summary"
            ].includes(props.route) ? (
              <i className="fas fa-check-square" />
            ) : (
              1
            )}
          </span>
          <span className="step-name">Basic Details</span>
        </div>
        <div
          onClick={() => _handleNavClick("quote")}
          className={`step ${props.route === "planDetails" ? "active" : ""} ${[
            "declarations",
            "nomineeDetails",
            "payment",
            "paymentSuccess",
            "summary"
          ].includes(props.route)
            ? "completed"
            : ""
            }`}
        >
          <span className="step-index">
            {[
              "declarations",
              "nomineeDetails",
              "payment",
              "paymentSuccess",
              "summary"
            ].includes(props.route) ? (
              <i className="fas fa-check-square" />
            ) : (
              2
            )}
          </span>
          <span className="step-name">Plan Details</span>
        </div>
        </>}
        <div
          onClick={() => _handleNavClick("nominee")}
          className={`step ${props.route === "nomineeDetails" ? "active" : ""
            } ${["declarations", "payment", "paymentSuccess", "summary"].includes(
              props.route
            )
              ? "completed"
              : ""
            }`}
        >
          <span className="step-index">
            {["declarations", "payment", "paymentSuccess", "summary"].includes(
              props.route
            ) ? (
              <i className="fas fa-check-square" />
            ) : (
              3
            )}
          </span>
          <span className="step-name">Nominee</span>
        </div>
        <div
          onClick={() => _handleNavClick("payment")}
          className={`step ${props.route === "payment" ? "active" : ""} ${["payment", "paymentSuccess", "summary"].includes(props.route)
            ? "completed"
            : ""
            }`}
        >
          <span className="step-index">
            {["paymentSuccess", "summary"].includes(props.route) ? (
              <i className="fas fa-check-square" />
            ) : (
              4
            )}
          </span>
          <span className="step-name">
            {props.route === "summary" ? "Summary" : `Payment`}
          </span>
        </div>
      </div>
    );
  };
  const _handleNavClick = (step) => {
    const {
      journey: { status },
      custId,
      source,
      product
    } = pasaStore;
    if (["JOURNEY_ACTIVE", "USER_DROPPED"].includes(status)) {
      let currentStep = history.location.pathname.split("/")[1];
      if (currentStep === "basic-details") {
        return false;
      } else if (currentStep === "quote" && ["basic-details"].includes(step)) {
        history.push(`/${step}/${product}/${source}/${window.btoa(custId)}`);
      } else if (
        currentStep === "nominee" &&
        ["basic-details", "quote"].includes(step)
      ) {
        history.push(`/${step}/${product}/${source}/${window.btoa(custId)}`);
      } else if (
        currentStep === "payment" &&
        ["basic-details", "quote", "nominee"].includes(step)
      ) {
        history.push(`/${step}/${product}/${source}/${window.btoa(custId)}`);
      } else {
        return false;
      }
    }
  };
  return (
    <div className="app-header">
      <div className="wrapper">
        <div className="grid" md={isLeadCapture ? 12 : 4} xs={7}>
          <div className="content">
            <div className={isLeadCapture ? "logo-cntnr1" : "logo-cntnr"}>
              {!["RTL_HBANK","LEAD_CAPTURE","CROSS_SELL"].includes(openMarket?.source?.toUpperCase()) && (
                  <div className="left-img">
                    {BELAIR_PARTNER.includes(source) ? (
                      <img src={BelairLogo} alt="instainsure" />
                        ) : (
                          <>
                        <img src={InstainsureLogo} alt="instainsure" />
                        </>
                      )}
                  </div>
              )}
            <div className="right-img2">
              {/* <img src={HDFCLOGO} alt="HDFC" /> */}
              <img src={HLifeLogo} alt="HDFC LIFE" />
              {source === "IDFC" && (
                <img src={IDFCLogo} alt="instainsure" className="IDFCLogo" />
              )}
            </div>
          </div>
          </div>
        </div>
        <div className="grid hidden-xs" md={6}>
          <div className="content">
            {props.route !== "welcome" && _stepper()}
          </div>
        </div>
      </div>
    </div>
  );
}
// export default withRouter(AppHeader);
